import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { device } from '../../../utils/helpers'
import { OuterWrapper, InnerWrapper, CardHeader, CardFooter, Image } from './Common'

const Title = styled.h2`
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  color: #fff;
  ${''/* padding-bottom: 10px; */}
  padding-bottom: 0.5208333333333334vw;
  font-size: 16px;

  @media ${device.tablet} {
    font-size: 1.875vw;
  }
`

const SubTitle = styled.p`
  font-family: 'BarlowSemiBold';
  color: #fff;
  font-size: 12px;

  @media ${device.tablet} {
    font-size: 1.09375vw;
  }
`

const FooterTitle = styled.h3`
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  color: #4d4d4d;
  padding-bottom: 5px;
  font-size: 16px;

  @media ${device.tablet} {
    font-size: 1.25vw;
  }
`

const FooterText = styled.p`
  font-family: 'BarlowSemiBold';
  color: #4d4d4d;
  padding-bottom: 2px;
  font-size: 12px;

  @media ${device.tablet} {
    font-size: 1.25vw;
  }
`

const SportCard = ({ title, selected, footerText1, footerText2, description, image, to, ...props }) => {
  return (
    <OuterWrapper to={to} selected={selected} {...props}>
      <CardHeader selected={selected}>
        <Title>{title}</Title>
        <SubTitle>{description}</SubTitle>
      </CardHeader>
      <InnerWrapper>
        <Image src={image} />
      </InnerWrapper>
      <CardFooter>
        <FooterTitle>TIPOLOGIE</FooterTitle>
        <FooterText>{footerText1}</FooterText>
        <FooterText>{footerText2}</FooterText>
      </CardFooter>
    </OuterWrapper>
  )
}

SportCard.propTypes = {
  /**
   * Title of the Card
   */
  title: PropTypes.string,
  /**
   * Indicates if the card has been selected
   */
  selected: PropTypes.bool,
  /**
   * Text Line 1 at the bottom of the Card
   */
  footerText1: PropTypes.string.isRequired,
  /**
   * Text Line 2 at the bottom of the Card
   */
  footerText2: PropTypes.string.isRequired,

  /**
   * Description of the Card
   */
  description: PropTypes.string,

  /**
   * Image of the Card
   */
  image: PropTypes.string.isRequired
}

export default SportCard



// WEBPACK FOOTER //
// ./src/components/Calculator/Card/SportCard.js